import { BrowserRouter } from 'react-router-dom';
import ReserveNowContainer, {
  ReserveNowContainerProps,
} from './reserveNowContainer';

const ReserveNowRouter = (props: ReserveNowContainerProps): JSX.Element => {
  return (
    <BrowserRouter basename="/reserve-now/">
      <ReserveNowContainer {...props} />
    </BrowserRouter>
  );
};

export default ReserveNowRouter;
